import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// CLAIM_ATTACHMENT

const mutation = gql`
  mutation claimAttachment(
    $claim_id: ID!
    $attachments: [ClaimAttachmentInput!]!
  ) {
    claimAttachment(claim_id: $claim_id, attachments: $attachments) {
      id
      medical_bills {
        id
        short_url
        scan_status
        content_type
        title
        notes
      }
    }
  }
`

export default function useClaimAttachment(
  successMessage = 'File has been attached to the Bill Claim!'
) {
  const { onMutate: onClaimAttachment, loading } = useSafeRunMutation({
    mutation,
    successMessage,
    responsePath: 'claimAttachment'
  })
  return { onClaimAttachment, loading }
}
